// Dashboard.js

import React, { useState , useEffect } from "react"
import Sidebar from "./Sidebar";
import Header from "./Header";
import CRM from "./CRM";
// import Analyze from "./Analyze"
import Callhistory from "./CallHistory/Callhistory";
import DoNotDisturb from "./DoNotDisturb";
import NotAttendedCalls from "./CallbackList";
import WaitingList from "./WaitingList";
import Dashrigmo from "./Dashrigmo";
import Agentscce from "./Agentscce";
import ClientSubscriptions from "./ClientSubscriptions";
import { useNavigate } from "react-router-dom";
import GetStarted from "../login/GetStarted";
import CallFlow from "./CallFlow";
import Configuration from "./Configuration";

const Dashboard = () => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(true);
  const [view, setView] = useState("CRM");
   const [loading, setLoading] = useState(true);
  // const [username, setUsername] = useState(localStorage.getItem("username") || "");
  const [user, setUser] = useState(null);

  const [introCompleted, setIntroCompleted] = useState(null);
  const navigate = useNavigate();







  // useEffect(() => {
  //   const storedUser = JSON.parse(localStorage.getItem("user"));
  //   const isLoggedIn = localStorage.getItem("isLoggedIn") === "true";
  //   const role = localStorage.getItem("role");

  //   if (!isLoggedIn || !storedUser) {
  //     navigate("/"); // Redirect to login if not logged in
  //   } else {
  //     setUser(storedUser);
  //     // Check role and intro status
  //     if (role !== "user") {



  //       setIntroCompleted(true); // Skip intro for non-users
  //     }
  //   }
  // }, [navigate])
  
  useEffect(() => {
    const storedUser = JSON.parse(localStorage.getItem("user"));
    const isLoggedIn = localStorage.getItem("isLoggedIn") === "true";

    const loadData = async () => {
      // Ensure loader shows for at least 2 seconds
      const startTime = Date.now();
     
      // Calculate elapsed time and wait if necessary
      const elapsedTime = Date.now() - startTime;
      const remainingTime = 320 - elapsedTime;
      
      if (remainingTime > 0) {
        await new Promise(resolve => setTimeout(resolve, remainingTime));
      }
      
      setLoading(false);
    };

    
    loadData();
    if (!isLoggedIn || !storedUser) {
      navigate("/");
      return;
    }

    setUser(storedUser);

    const fetchIntroStatus = async () => {
      try {
        const response = await fetch(`${process.env.REACT_APP_SERVER_API}/api/intro-data/${storedUser.id}`);
        const data = await response.json();
        if (response.ok) {
          setIntroCompleted(data.introData.introCompleted);
        }
      } catch (error) {
        console.error("Error fetching intro status:", error);
      }
    };

    fetchIntroStatus();
  }, [navigate]);

  if (!user || introCompleted === null) return null;

  if (!introCompleted) {
    return <GetStarted />;
  }
  
  const handleLogout = () => {
 localStorage.clear();
  sessionStorage.clear(); window.location.href = "/" };



// If user or introCompleted is still loading, show a loading state
if (!user || introCompleted === null) {
  return <div>Loading...</div>;
}

// If intro is not completed, show GetStarted
if (!introCompleted) {
  return <GetStarted />;
}
      

  // // If user data is still loading or invalid, return null to avoid rendering
  // if (!user) return null;

  // // Render Introduction for "user" role if intro not completed
  // if (user.role === "user" && !introCompleted) {
  //   return <GetStarted setIntroCompleted={setIntroCompleted} />;

  if (loading) return (
    <div className="flex items-center justify-center h-[calc(100vh-4rem)] sm:h-[calc(100vh-5rem)] bg-gray-50">
      <div className="flex flex-col items-center">
        <div className="animate-spin rounded-full h-12 w-12 sm:h-16 sm:w-16 border-t-4 border-blue-500 border-solid"></div>
        <p className="mt-4 text-lg text-gray-600">Loading your subscription details...</p>
      </div>
    </div>
  );
  return (
    <div className="flex h-screen">
      <Sidebar
        isSidebarOpen={isSidebarOpen}
        setIsSidebarOpen={setIsSidebarOpen}
        setView={setView}
        // username={username}
        handleLogout={handleLogout}
        user={user?.name}
      />
      <div className="flex-1 overflow-y-auto h-screen">
        <Header user={user?.name}  />

        {view === "Dashboard" && <Dashrigmo setView={setView} user={user} ></Dashrigmo>}
        {view === "CRM" && <CRM  user={user}  />}
        {view === "Agents-CCE" && <Agentscce user={user} ></Agentscce>}
        {view === "CallHistory" && <Callhistory   user={user} />}
        {view === "DoNotDisturb" && <DoNotDisturb user={user}   />}


        {view === "NotAttendedCalls" && <NotAttendedCalls user={user}   ></NotAttendedCalls>}

        {view === "WaitingList" && <WaitingList user={user}  ></WaitingList>}


        {view === "Configuration" && <Configuration user={user}  ></Configuration>}

        {view === "Subscriptions" && <ClientSubscriptions  user={user}></ClientSubscriptions>}
        {view === "CallFlow" && <CallFlow user={user}   />}
      </div>
    </div>
  );
};

export default Dashboard;
